/* Pop&Go — suscripción a Klaviyo (Client API, CORS público).
   El suscriptor entra a la lista en Klaviyo y, vía la integración Klaviyo↔Shopify,
   se sincroniza al Customer en Shopify. Keys desde window.POPGO.klaviyo. */
(function () {
  'use strict';
  var CFG = window.POPGO || {};
  var K = CFG.klaviyo || {};
  var form = document.getElementById('newsletter-form');
  if (!form || !K.key || !K.list) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var btn = document.getElementById('newsletter-btn');
    var msg = document.getElementById('newsletter-msg');
    var input = document.getElementById('newsletter-email');
    var email = (input.value || '').trim();
    if (!email) return;

    btn.disabled = true;
    btn.textContent = 'Enviando…';

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(K.key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'pop&go web',
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: K.list } } }
        }
      })
    }).then(function (res) {
      if (res.status !== 202 && !res.ok) throw new Error('HTTP ' + res.status);
      btn.textContent = '¡Bienvenido al club!';
      btn.classList.add('bg-blanco');
      msg.classList.remove('hidden');
      msg.innerHTML = '🎉 Te suscribiste a la lista de pop&go. Te llegará un correo de confirmación.';
      input.value = '';
    }).catch(function (err) {
      console.error('[pop&go] newsletter error:', err);
      btn.textContent = 'Hubo un error';
      msg.classList.remove('hidden');
      msg.innerHTML = '⚠️ No pudimos suscribirte. Escríbenos a popandgo.chile@gmail.com.';
    }).then(function () {
      setTimeout(function () {
        btn.textContent = 'Suscribirme';
        btn.classList.remove('bg-blanco');
        btn.disabled = false;
      }, 6000);
    });
  });
})();
